export default __webpack_public_path__ + "static/media/publicBanner03.97822cfa.jpg";